import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { BaseAuditViewer } from "@app/view/shared/audits/base/base-audit-viewer";
import { RowExpanderConfig } from "@bryntum/grid-thin";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent
} from "@angular/material/dialog";
import { AuditService } from "@app/services/http/audit.service";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { MatCheckbox } from "@angular/material/checkbox";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { GridComponent as GridComponent_1 } from "../../base-pages/base-data-table-page/grid.component";
import { DialogHeaderComponent } from "../../dialog-header/dialog-header.component";

@Component({
  selector: "scheduler-visit-audit-viewer",
  templateUrl: "./visit-audit-viewer.component.html",
  styleUrls: ["./visit-audit-viewer.component.css"],
  imports: [
    MatCheckbox,
    CdkScrollable,
    MatDialogContent,
    GridComponent_1,
    DialogHeaderComponent
  ]
})
export class VisitAuditViewerComponent
  extends BaseAuditViewer
  implements OnInit
{
  dialogRef = inject<MatDialogRef<VisitAuditViewerComponent>>(MatDialogRef);
  data = inject<{
    visitId: number;
  }>(MAT_DIALOG_DATA);
  auditService: AuditService;

  public rowExpanderConfig: Partial<RowExpanderConfig> = {
    columnPosition: "first",
    renderer: async (renderData) => {
      console.log("Rendering expander for record ", renderData.record);
      let renderString = `<visit-audit-renderer style="width:100%" snapshot-id="${
        renderData.record.get("majorId") +
        "." +
        renderData.record.get("minorId")
      }" visit-id="${renderData.record.get(
        "entityId"
      )}"></visit-audit-renderer>`;
      console.log("renderString", renderString);
      return renderString;
    }
  };

  @ViewChild(GridComponent, { static: true }) auditGrid: GridComponent;

  constructor() {
    const auditService = inject(AuditService);

    super(auditService, "visit");

    this.auditService = auditService;
  }

  ngOnInit(): void {
    this.queryAudit(this.data.visitId, "visit", this.auditGrid);
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
